// KHÔNG hijack scroll (libraryMainsite tự quản scroll/scale, hijack sẽ bị đánh
// nhau -> nặng, kẹt frame). Chỉ thêm entrance animation: gắn .is-inview cho
// frame khi vào viewport; CSS lo phần fade/slide. Cuộn giữ native của lib.
window.addEventListener("load", function () {
  if (!("IntersectionObserver" in window)) return;
  // Section nằm trong #frameTrack (không phải con trực tiếp #MS__wrapper).
  var track = document.getElementById("frameTrack") ||
    document.getElementById("MS__wrapper");
  if (!track) return;
  var frames = Array.prototype.filter.call(track.children, function (el) {
    return el.tagName === "SECTION";
  });
  if (!frames.length) return;

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (en.isIntersecting) en.target.classList.add("is-inview");
      else en.target.classList.remove("is-inview");
    });
  }, { threshold: 0.2 });

  frames.forEach(function (f) { io.observe(f); });
});
